export enum Errors {
  required = "Required!",
  email = "Email is not valid!",
  currentEmail = "It is the user email!",
  existingCollaborator = "Yor added this user already",
  password = "Password must be 8 characters long!",
  name = "Try to avoid gaps in the name!",
  tag = "Tag must be 20 characters long!",
}
